import React from 'react'
import styled from 'styled-components'

const StyledContactBoxes = styled.div`
  background-color: ${({ theme }) => theme.colors.sectionLightBg};
  justify-content: center;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;

  ${({ theme }) => theme.media.desktop} {
    display: flex;
    margin: 0 auto;
    padding-bottom: 60px;
    position: relative;
  }
`

const ContactBoxes = ({ children }) => {
  return <StyledContactBoxes>{children}</StyledContactBoxes>
}

export default ContactBoxes
